"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image from "@/components/ui/CardImage";
import { FiChevronLeft, FiSearch, FiMoreVertical, FiScissors, FiDownload, FiMonitor, FiShare2, FiMessageSquare } from "react-icons/fi";
export default function PageHeader() {
  const $ = _c(11);
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button className="flex items-center gap-1 hover:bg-gray-100 px-3 py-2 rounded-md transition-colors" onClick={_temp}><FiChevronLeft size={24} className="text-1B1B1B" /><span className="text-24-tamil-500">Back</span></button>;
    t1 = <div><Image src="https://media.dinamani.com/dinamani/2026-02-27/y9s7ztw3/dinamanilogo.png" alt="logo" width={200} height={80} className="object-contain" /></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" onClick={_temp2}><FiSearch size={22} className="text-[#001F5B]" /></button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== open) {
    t3 = () => setOpen(!open);
    $[3] = open;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FiMoreVertical size={22} className="text-[#001F5B]" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== open) {
    t5 = open && <div className="absolute right-0 mt-2 w-44 bg-white shadow-lg rounded p-2 animate-fade-in"><MenuItem icon={<FiScissors />} label="All Clips" /><MenuItem icon={<FiDownload />} label="My Downloads" /><MenuItem icon={<FiMonitor />} label="HD View" /><MenuItem icon={<FiShare2 />} label="Share" /><MenuItem icon={<FiMessageSquare />} label="Send Feedback" /></div>;
    $[6] = open;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="w-full relative"><div className="flex items-center justify-between px-4 h-[154px] bg-white">{t0}{t1}<div className="flex items-center gap-4">{t2}<div className="relative cursor-pointer" onClick={t3}>{t4}{t5}</div></div></div></div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp2() {}
function _temp() {
  return window.history.back();
}
function MenuItem(t0) {
  const $ = _c(5);
  const {
    icon,
    label
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="text-xl">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <div className="flex items-center gap-3 px-2 py-2 hover:bg-gray-100 rounded-md cursor-pointer text-[15px]">{t1} {label}</div>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}